export default __webpack_public_path__ + "static/media/l.4f202296.svg";